import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2'; // solo para desplegar error desde repository 
// no pude hacerlo con modal de bootstrap desde allí
// sweet alert funciona como un alert() de js pero mejor visualización
const options = {
    confirmButtonColor: '#ff4063',
    cancelButtonColor: '#fff'
};

Vue.use(VueSweetalert2, options);

const swal = Vue.swal;

export {
    swal
};